function readBlockData(block) {
  try {
    const text = block?.text;
    const html = block?.html;
    if (typeof text !== "string" || typeof html !== "string" || !html) return null;
    return { text, html };
  } catch {
    return null;
  }
}

export async function copyBlock({ block, writeClipboard } = {}) {
  try {
    const data = readBlockData(block);
    if (!data || typeof writeClipboard !== "function") return false;
    await writeClipboard(data);
    return true;
  } catch {
    return false;
  }
}

export async function cutBlock({ block, writeClipboard, deleteBlock } = {}) {
  if (!await copyBlock({ block, writeClipboard })) return false;
  try {
    if (typeof deleteBlock !== "function") return false;
    return await deleteBlock() !== false;
  } catch {
    return false;
  }
}

export async function writeBlockToClipboard(block, options = {}) {
  const data = readBlockData(block);
  if (!data) throw new Error("invalid block clipboard data");

  const clipboard = options?.clipboard === undefined
    ? globalThis.navigator?.clipboard
    : options.clipboard;
  const ClipboardItemCtor = options?.ClipboardItemCtor === undefined
    ? globalThis.ClipboardItem
    : options.ClipboardItemCtor;
  const BlobCtor = options?.BlobCtor === undefined ? globalThis.Blob : options.BlobCtor;
  if (!clipboard) throw new Error("clipboard unavailable");

  if (typeof ClipboardItemCtor === "function"
    && typeof BlobCtor === "function"
    && typeof clipboard.write === "function") {
    const item = new ClipboardItemCtor({
      "text/html": new BlobCtor([data.html], { type: "text/html" }),
      "text/plain": new BlobCtor([data.text], { type: "text/plain" })
    });
    await clipboard.write([item]);
    return;
  }
  if (typeof clipboard.writeText !== "function") throw new Error("clipboard unavailable");
  await clipboard.writeText(data.text);
}

export function createBlockCommandServices({ editor, writeClipboard } = {}) {
  const ok = { ok: true };
  const clipboardFailure = { ok: false, message: "无法访问剪贴板，原内容已保留" };
  const deleteFailure = { ok: false, message: "当前块无法删除" };
  const cutDeleteFailure = { ok: false, message: "内容已复制，但原块未删除/已变化" };

  async function currentBlock() {
    try {
      return typeof editor?.getCurrentBlockClipboardData === "function"
        ? await editor.getCurrentBlockClipboardData()
        : null;
    } catch {
      return null;
    }
  }

  async function deleteCurrentBlock(expectedBlock) {
    try {
      if (typeof editor?.deleteCurrentBlock !== "function") return false;
      return await editor.deleteCurrentBlock(expectedBlock) !== false;
    } catch {
      return false;
    }
  }

  return {
    "block-copy": async () => await copyBlock({
      block: await currentBlock(), writeClipboard
    }) ? ok : clipboardFailure,
    "block-cut": async () => {
      const block = await currentBlock();
      const copied = await copyBlock({ block, writeClipboard });
      if (!copied) return clipboardFailure;
      return await deleteCurrentBlock(block) ? ok : cutDeleteFailure;
    },
    "block-delete": async () => await deleteCurrentBlock() ? ok : deleteFailure
  };
}
